import { useEffect } from 'react';

const PrerenderReady = () => {
  useEffect(() => {
    if (window.prerenderReady !== true) {
      window.prerenderReady = true;
    }
  });

  return null;
};

export default PrerenderReady;
